import { jsx } from "react/jsx-runtime";
export const ReactComponent = (props) => /* @__PURE__ */ jsx("svg", { ...props, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ jsx("path", { d: "M13.2353 4L5 12L13.2353 20M19 4L10.7647 12L19 20", stroke: "black" }) });
